import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "Angaben gemäß § 5 TMG",
    body: (
      <p className="notranslate" translate="no">
        <span className="text-white">the </span><span className="text-cyan-400">coolpool</span><span className="text-white"> company GmbH</span>
        <br />
        Auf'm Reck 65
        <br />
        33334 Gütersloh
      </p>
    ),
  },
  {
    heading: "Vertreten durch",
    body: <p>Josefin Bröckelmann</p>,
  },
  {
    heading: "Kontakt",
    body: (
      <p>
        Telefon: 0175 - 1600677
        <br />
        E-Mail:{" "}
        <a href="mailto:info@cool-pool-company.de" className="text-cyan-300 hover:text-cyan-200 transition-colors">
          info@cool-pool-company.de
        </a>
      </p>
    ),
  },
  {
    heading: "Registereintrag",
    body: (
      <p>
        Eintragung im Handelsregister.
        <br />
        Registergericht: Amtsgericht Gütersloh
        <br />
        Registernummer: HRB 14293
      </p>
    ),
  },
  {
    heading: "Umsatzsteuer-ID",
    body: (
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        <br />
        DE459323998
      </p>
    ),
  },
  {
    heading: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
    body: <p>Sonja Bröckelmann</p>,
  },
  {
    heading: "EU-Streitschlichtung",
    body: (
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Unsere
        E-Mail-Adresse finden Sie oben im Impressum.
      </p>
    ),
  },
  {
    heading: "Verbraucherstreitbeilegung / Universalschlichtungsstelle",
    body: (
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    ),
  },
  {
    heading: "Haftung für Inhalte",
    body: (
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
        allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung
        der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
        diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
        möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>
    ),
  },
  {
    heading: "Haftung für Links",
    body: (
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
        verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
        verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche
        Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
        zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
    ),
  },
  {
    heading: "Urheberrecht",
    body: (
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
        Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
        auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </p>
    ),
  },
];

export default function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" testId="impressum-page">
      {sections.map((s) => (
        <section key={s.heading} className="mb-9">
          <h2 className="font-display font-semibold text-xl text-white mb-3">{s.heading}</h2>
          <div className="text-sm sm:text-base text-slate-300/90 leading-relaxed font-light">{s.body}</div>
        </section>
      ))}
    </LegalLayout>
  );
}
